<template>
  <div class="inf">
    
    <div class="inf-content">
      <el-col>
        <el-steps :active="active" finish-status="success" simple style="margin-top: 20px" v-if="ruleForm.status !== 1" >
          <el-step title="基本信息" ></el-step>
          <el-step title="实名认证" ></el-step>
          <el-step title="我的资质" ></el-step>
          <el-step title="审核" ></el-step>
        </el-steps>
        <div class="Notice" v-if="ruleForm.status !== 1">
          <el-alert :closable="false"
                    title="温馨提示"
                    description="为能给药师及患者提供更多的安全保证，
                    药师只要信息经过审核通过以后，才可以审方。审核通过后,我的资质与实名认证信息不能更改。
                    如果审核被拒，请根据审核失败信息，补充并提交信息。
                    隐私信息未经本人许可严格保密。"
                    type="info" show-icon>
          </el-alert>
        </div>
        <div style="height: 300px;position: absolute;z-index:9999;">
          <el-steps direction="vertical" v-if="ruleForm.status == 1" :active="actives">
            <el-step title="基本信息" icon="el-icon-s-custom" @click.native="on_click(1)"></el-step>
            <el-step title="实名认证" icon="el-icon-s-check" @click.native="on_click(2)"></el-step>
            <el-step title="我的资质" icon="el-icon-s-order" @click.native="on_click(3)"></el-step>
          </el-steps>
        </div>
        <router-view></router-view>
        <div class="hint_info" style="" v-if="ruleForm.status == 1">
          <span> <i>*</i> 您提交的信息已经审核通过，不能修改实名认证、资质信息中内容；</span>
          <span> <i>*</i> 如需再次修改，请点击“再次修改”，请您确认，“再次修改”您的审核状态将会变为“待审核”，需要重新提交信息，审核通过后，才能正常使用。请谨慎操作！</span>

<!--          <el-button class="again_btn" @click="againChange()">再次修改</el-button>-->
        </div>
      </el-col>
    </div>
  </div>
</template>
<script>
import {
  getDoctorInfo,
} from "@/api/index.js";
import {mapState} from 'vuex'
export default {
  props: {
    userData: Object,
  },
  data() {
    return {
      ruleForm: {},
      // 步骤条
      actives: 1,
    }
  },
  mounted() {
    this.getUserInfo();
    console.log('21321321',this.active);
    
  },
  computed:{
    ...mapState(['active'])
  },
  methods: {
  
    /**
     * @desc 个人信息回显
     */
    async getUserInfo() {
      try {
        const params = {};
        let res = await getDoctorInfo(params);
        if (res.success) {
          this.ruleForm = res.result;
          console.log(res.result);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 步骤条
    on_click(e){
      console.log(e);
      if(e == 1){
        this.actives = 1
         this.$router.push('/index/user/auditInformation/information') 
      }else if(e == 2){
        this.actives = 2
        this.$router.push('/index/user/auditInformation/authentication')
      }else if(e == 3){
        this.actives = 3
        this.$router.push('/index/user/auditInformation/qualifications')
      }
    },
    againChange(){
      console.log(this.ruleForm.status);
      this.$store.commit('againUpdate', true)
      this.$router.push('/index/user/auditInformation/information') 
      this.ruleForm.status = 0
    },
  }

};
</script>

<style lang="scss" scoped>
.el-button--primary {
  background-color: #fc701a;
  border-color: #fc701a;
}

.head-img {
  display: flex;
  flex-direction: row;
  .head-img-br {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    //   display: flex;
    //   align-items: center;
  }
}

.head-img-br span {
  margin: 0 0 14px 10px;
  font-size: 15px;
  color: #999999;
}

.avatar {
  width: 200px;
  height: 200px;
  margin-bottom: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.el-form-item__label {
  font-size: 16px;
}

/deep/ .form-item-info {
  width: 100%;
}

.information .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.info-left {
  width: 225px;
}
.inf {
  // width: 100%;
  // height: 965px;
  height: 100%;
  padding: 250px;
  padding-top: 39px;
  margin: 0 auto;

  // box-shadow: 0 0 50px #8c939d;
}
/* .inf-content {
  width: 65%;
  margin: 39px auto ;
} */
.row-info {
  .form-info {
    // position: absolute;

    margin: 20px -51% 0% 0;
    margin-left: -100px;
    padding-bottom: 25%;
    // min-width: 1800px;
    background: #ffffff !important;
    .info-col {
      margin: 0 !important;
    }
    .el-form-item-info-sex {
      margin-left: calc(20% - 28px);
      // .el-from-item-info-sex-redio.is-checked {
      //   color: #fc701a !important;
      // }
    }
    .loginBtn {
      width: 20%;
      margin-left: calc(25% + 120px);
      .customBtn {
        background: #fc701a !important;
        border: 0 !important;
      }
    }
  }
}

.customBtn {
  margin-left: calc(30% + 5px);
}

.form-info .form-item-info {
  width: 60%;
}

.row-info .el-form-item__content {
  margin: 0 !important;
}

.information .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.information .avatar-uploader .el-upload {
  margin-left: calc(45% - 5px);
}

.information .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.information .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.information .el-textarea__inner {
  border-color: #dcdfe6 !important;
}

/deep/.el-input__inner:focus {
  border: 1px solid #fc701a !important;
}
/deep/.el-textarea__inner:focus {
  border: 1px solid #fc701a !important; // 鼠标聚焦边框颜色
}

.el-cascader-node.in-active-path:focus {
  color: #fc701a !important;
}

#el_cascader /deep/ :foucs {
  color: #fc701a !important;
}

/* 选中后的字体颜色 */
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #fc701a !important;
}
/* 选中后小圆点的颜色 */
/deep/.el-radio__input.is-checked .el-radio__inner {
  background: #fc701a !important;
  border-color: #fc701a !important;
}
// /deep/.el-popper.el-cascader__dropdown + .el-cascader-panel + .el-scrollbar.el-cascader-menu +.el-cascader-menu__wrap.el-scrollbar__wrap+.el-scrollbar__view.el-cascader-menu__list+ .el-cascader-node.in-active-path + .el-cascader-node__label{
//   color: #fc701A !important;
// }

/deep/.el-radio__input .el-radio__inner:hover {
  border-color: #fc701a !important;
}

/deep/.form-item-info .el-textarea__inner:hover {
  border-color: #fc701a !important;
}
.Notice{
    width: 90%;
    display: flex;
    font-size: 14px;
    letter-spacing: 0.5px;
    color: #666;
    text-align: left;
    line-height: 20px;
    margin: 15px auto;
    border: 1px solid #cadff7;
    padding: 10px;
}
.head-img-br .head-img-check{
  font-style: normal;
  font-size: 16px;
  color: #02A7F0;
  cursor:pointer;
  right: 30px;
  bottom: 75px;
  position: absolute;
}
.head-img-br .headPortrait{
  position: absolute;
  right: -195px;
  top: 30px;
}
.hint_info{
  width:320px;
  height:275px; 
  position:absolute;
  right: 100px;
  top: 80px;
}
.hint_info span{
  font-size: 14px;
  color: #666;
  display: inline-block;
  line-height: 20px;
}
.hint_info span i{
  color: red;
}
.again_btn{
  display: block;
  width: 97px;
  height: 37px;
  margin: 10px auto 0;
}
.alert_text{
  width: 490px;
  margin-left: 20px;
}
</style>
